import { Component, OnInit, SimpleChanges } from '@angular/core';
import { StorageService } from '../services/storage/storage.service';
import { StorageKeys } from './share/enums/storage.enum';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'property-box';
  isLogin: boolean = false;
  status: any;
  isAdmin: boolean = false;

  constructor(private storageService: StorageService) { }

  ngOnInit() {
    // Check current enrollment type on init
    const currentStatus = this.storageService.getDataFromLocalStorage(StorageKeys.enrollmentType);
    this.isAdmin = currentStatus === 'Admin';
  
    // Subscribe to enrollment type updates
    this.storageService.enrollmentType$.subscribe((status) => {
      this.isAdmin = status === 'Admin';
    });
  }
  
}
